import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';

/**
 * Directiva para establecer un campo como 'required' dependiendo del valor pasado
 * @example
 * <label>Hijos</label><br/>
 * <input class="form-check-input" type="checkbox" [(ngModel)]="hasChildren" name="hasChildren">
 * <label>Nombre del primer hijo</label>
 * <input type="text" class="form-control" name="child1Name" [(ngModel)]="child1Name" [requiredIf]="!hasChildren" >
 * @tutorial
 * https://medium.com/front-end-hacking/angular-how-to-implement-conditional-custom-validation-1ec14b0feb45
 */
@Directive({
  selector: '[requiredIf]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: RequiredIfDirective, multi: true }
  ]
})
export class RequiredIfDirective implements Validator {

  @Input("requiredIf")
  requiredIf!: boolean;

  private _onChange: () => void;

  constructor() { }

  validate(control: AbstractControl) {
    let value = control.value;
    if ((value == null || value == undefined || value == "") && this.requiredIf) {
      return {
        requiredIf: { condition: this.requiredIf }
      };
    }
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('requiredIf' in changes) {
      if (this._onChange)
        this._onChange();
    }
  }

}
